/* eslint-disable no-console */
const isDevelopment = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV;

const logger = {
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
